import { queryBuilder } from '@inpart-io/devtools-iap';
import { RETRIEVE_BY_QUERY, STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { type IMandatoryFieldConfiguration, mandatoryFieldConfigurationProperties } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { RECEIVE_COMPLETE, RECEIVE_REFRESH_TIMESTAMP } from './mutations';
import { type IMandatoryFieldConfigState } from './types';

export const RETRIEVE_ALL_MANDATORY_CONFIGS = 'retrieveAllMandatoryConfigurations';
export const RETRIEVE_MANDATORY_CONFIGURATIONS = 'retrieveMandatoryConfigurations';
export const REFRESH = 'refreshMandatoryState';
export const UPDATE_COMPLETE = 'updateMandatoryComplete';

export const actions: ActionTree<IMandatoryFieldConfigState, unknown> = {
    async [RETRIEVE_ALL_MANDATORY_CONFIGS](context): Promise<number[]> {
        const query = queryBuilder.build();
        const idList = await context.dispatch(RETRIEVE_BY_QUERY, {
            query,
            properties: mandatoryFieldConfigurationProperties.DEFAULT
        });
        return idList;
    },
    [STORE_DATA_OBJECTS](context, { dataObjectList }: { dataObjectList: IMandatoryFieldConfiguration[] }) {
        dataObjectList.forEach((mandatoryFieldConfig) => {
            context.state.mandatoryFieldConfigurationByClassName.set(mandatoryFieldConfig.forClassName, mandatoryFieldConfig.dobjId);
            context.state.dataObjectList.set(mandatoryFieldConfig.dobjId, mandatoryFieldConfig);
        });
    },
    [REFRESH](context) {
        context.commit(RECEIVE_REFRESH_TIMESTAMP, { timestamp: Date.now() });
    },
    [UPDATE_COMPLETE](context, { complete }: { complete: boolean }) {
        context.commit(RECEIVE_COMPLETE, { complete });
    }
};
